export type PresetCode = 'immersive' | 'interactive' | 'novel'

export const DEFAULT_PRESET_CODE: PresetCode = 'immersive'

const PRESET_TEMPLATE_ID_TO_CODE: Record<string, PresetCode> = {
  'c1000001-0000-4000-8000-000000000001': 'immersive',
  'c1000002-0000-4000-8000-000000000002': 'interactive',
  'c1000003-0000-4000-8000-000000000003': 'novel',
}

export function resolvePresetCode(templateId: unknown): PresetCode {
  if (typeof templateId !== 'string') return DEFAULT_PRESET_CODE
  return PRESET_TEMPLATE_ID_TO_CODE[templateId] ?? DEFAULT_PRESET_CODE
}
